import { configureStore } from "@reduxjs/toolkit";

import loginReducer from "../components/screen/login/redux/loginReducer";
import menuReducer from "../components/screen/login/redux/menuReducer";
import walletReducer from "../components/screen/login/redux/walletReducer";

export const store = configureStore({
  reducer: {
    loginReducer,
    menuReducer,
    walletReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
      immutableCheck: false,
    }),
});
